export default __webpack_public_path__ + "static/media/noImage.368deef0.svg";